    <div class="flex flex-col h-full">
        <div class="overflow-y-auto">
            <div class="flex items-center justify-center py-[8%]">
                <div class="backdrop-blur-lg bg-white/18 border border-white border-white/18 rounded-3xl p-4 md:p-8 max-w-md w-full text-center shadow-2xl">
                    <!-- Success Icon -->
                    <i class="material-symbols-outlined text-emerald-500 !text-[50px] md:!text-[70px]">
                        task_alt
                    </i>

                    <!-- Success Message -->
                    <div class="mb-8" >
                        <h1 class="text-4xl md:text-5xl font-bold !text-white mb-4">
                            <!--i18n - Success! -->
                            {{ 'i18n.app.features.pages.order.wizard.payment-result.success.h1_01' | translate }} 
                        </h1>
                        <p class="text-xl text-white text-opacity-90 mb-2">
                            <!--i18n - Payment Completed -->
                            {{ 'i18n.app.features.pages.order.wizard.payment-result.success.p_01' | translate }} 
                        </p>
                        <p class="text-white text-opacity-70">
                            <!--i18n - Your transaction has been processed successfully -->
                            {{ 'i18n.app.features.pages.order.wizard.payment-result.success.p_02' | translate }} 
                        </p>
                    </div>

                    <!-- Payment Details -->
                    <div class="backdrop-blur-lg bg-white/18 rounded-2xl p-6 mb-8 border bg-white/18">
                        <div class="flex justify-between items-center mb-4">
                            <span class="text-white text-opacity-70">
                                <!--i18n - Amount -->
                                {{ 'i18n.app.features.pages.order.wizard.payment-result.success.span_01' | translate }}
                            </span>
                            <span class="text-2xl font-bold text-white">€ {{ _orderWizardService.orderWizard$()?.step01?.pricingSummary?.total }}</span>
                        </div>
                        <div class="flex justify-between items-center mb-4">
                            <span class="text-white text-opacity-70">
                                <!--i18n -  Order code -->
                                {{ 'i18n.app.features.pages.order.wizard.payment-result.success.span_02' | translate }}
                            </span>
                            <span class="text-white font-mono text-sm"> {{ _orderWizardService.orderWizard$()?.step01?.code }}</span>
                        </div>
                        <div class="flex justify-between items-center">
                            <span class="text-white text-opacity-70">
                                <!--i18n - Date -->
                                {{ 'i18n.app.features.pages.order.wizard.payment-result.success.span_03' | translate }}
                            </span>
                            <span class="text-white">{{ _orderWizardService.orderWizard$()?.step01?.dateCreate | date }}</span>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="space-y-4">
                        <button 
                            routerLink="/"
                            class="w-full bg-transparent border-2 border-white border-opacity-30 text-white font-semibold py-4 px-6 rounded-2xl hover:bg-white hover:bg-opacity-10 transition-all duration-300 transform hover:scale-105">
                            <!--i18n - Continue Shopping -->
                            {{ 'i18n.app.features.pages.order.wizard.payment-result.success.button_02' | translate }}
                        </button>
                    </div>

                    <!-- Footer Message -->
                    <div class="mt-8 text-white text-opacity-60 text-sm" style="animation-delay: 0.8s;">
                        <p>
                            <!--i18n - Thank you for your purchase! -->
                            {{ 'i18n.app.features.pages.order.wizard.payment-result.success.p_03' | translate }}
                        </p>
                        <p>
                            <!--i18n - A confirmation email has been sent to your inbox. -->
                            {{ 'i18n.app.features.pages.order.wizard.payment-result.success.p_04' | translate }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- TODO: a remettre le cas echeant -->
            <!-- <div class="flex items-center justify-center">
                <div class="mt-8 text-white text-opacity-60 text-sm">
                    <p>--debug Stripe--</p>
                    <p>id transaction: {{ _orderWizardService.orderWizard$()?.step06?.stripeId }}</p>
                    <p>id transaction: {{ _orderWizardService.orderWizard$()?.step06?.status }}</p>
                    <h4>TODO : Finaliser l'ordre & envoyer le message à roger</h4>
                </div>
            </div> -->
        </div>
    </div>
